// 文件路径 @/util/echarts-config.js 自行配置
// 加载echarts，注意引入文件的路径
import * as echarts from 'echarts/lib/echarts'

// 再引入你需要使用的图表类型，标题，提示信息等
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/graph' // 引入关系图(graph)
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/toolbox' // 引入工具箱

export default echarts

